import {
  AfterViewInit,
  Component,

  OnInit,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Reservation } from "src/app/models/reservation-model";
import { AuthService } from "src/app/services/auth/auth.service";
import { DateFormatterService } from "src/app/services/date-formatter/date-formatter.service";
import { DefaultService } from "src/app/services/default/default.service";
import { ReservationService } from "src/app/services/reservation/reservation.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
  selector: 'app-mes-reservations',
  templateUrl: './mes-reservations.component.html',
  styleUrls: ['./mes-reservations.component.scss']
})
export class MesReservationsComponent implements OnInit, AfterViewInit {
  status: any = {
    "canceled": { text: "Annulé", class: "badge badge-danger" },
    "pending":{ text: "En attente" , class: "badge badge-warning" },
    "waiting-confirmation":{ text: "En attente de confirmation" , class: "badge badge-primary" },
    "confirmed":{ text: "Confirmé", class: "badge badge-success" },
    "failed":{ text: "Échoué" , class: "badge badge-danger" },
  };

  statusEntries: Array<{ key: string; value: any }> = [];

  nbr_items_in_page: number = 8;
  total_items: number = 0;
  current_page: number = 1;
  page_count: number = 1;

  loading: boolean = true;
  reservations: Array<Reservation> = [];
  has_more: boolean = false;

  selectedStatus: string = "";

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private reservationService: ReservationService,
    private defaultService: DefaultService,
    private dateFormatterService: DateFormatterService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.statusEntries = Object.entries(this.status).map(([key, value]) => ({
      key,
      value,
    }));
    this.activatedRoute.queryParams.subscribe((params) => {
      this.current_page = params["page"] ? params["page"] : 1;
      this.get_my_reservations(true);
    });
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  get_my_reservations(scrolToTop: boolean) {
    this.loading = true;
    this.spinner.show();

    let filters =
      "?populate=*&sort[0]=createdAt%3Adesc&pagination[pageSize]=" +
      this.nbr_items_in_page.toString() +
      "&pagination[page]=" +
      this.current_page.toString();

    if (this.selectedStatus != "") {
      filters += "&filters[status]=" + this.selectedStatus;
    }

    let profile = this.authService.currentUserValue?.is_connect_with
      ? "&profile=" + this.authService.currentUserValue?.profile?.id
      : "";

      filters += profile;

    this.reservationService
      .get(filters)
      .subscribe(
        (res) => {
          this.total_items = res.meta.pagination.total;
          this.page_count = res.meta.pagination.pageCount;
          this.has_more =
            res.data.length == this.nbr_items_in_page ? true : false;

          res.data.forEach((item: any) => {
            this.reservations.push(
              new Reservation(Reservation.attributeToJson(item))
            );
          });

          setTimeout(() => {
            Webflow.setIFrameHeight(scrolToTop, this.current_page * 40);
          }, 500);
        },
        (err) => {
          Webflow.setIFrameHeight();

          this.current_page = 1;
          this.reservations = [];
          Swal.fire({
            title: "Erreur",
            text: "Une érreur est survenue",
            icon: "error",
            position: "top",
          });
        }
      )
      .add(() => {
        this.spinner.hide();
        this.loading = false;
      });
  }

  redirectToWebflow(slug: string) {
    const baseUrl = environment.webflow_url;
    return `${baseUrl}${slug}`;
  }

  get_more() {
    this.current_page++;
    this.get_my_reservations(false);
  }

  navigateTo(actionName: string) {
    Webflow.myAction(this.router,actionName, {});
  }

  annuler(reservation: Reservation) {
    Webflow.setIFrameHeight();
    Swal.fire({
      title: "Annuler la réservation",
      text: "Étes-vous sûre de vouloir annulée la réservation ?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Confirmer`,
      cancelButtonText: `Annuler`,
      position: "top",
      cancelButtonColor: "black",
      confirmButtonColor: "#D63333",
    }).then((result) => {
      if (result.isConfirmed) {
        this.defaultService
          .post("reservations/" + reservation.id + "/cancel", {})
          .subscribe(
            (res) => {
              Swal.fire({
                title: "Félicitation",
                text: "La réservation a été annulée avec succès",
                icon: "success",
                position: "top",
              });
              this.current_page = 1;
              this.reservations = [];
              this.get_my_reservations(true);
            },
            (error) => {
              if (GenerateErrors.check_if_is_custom_error(error)) {
                Swal.fire({
                  title: "Érreur",
                  text: GenerateErrors.get_message_error(error),
                  icon: "error",
                  position: "top",
                });
              } else {
                Swal.fire({
                  title: "Erreur",
                  text: "Une érreur est survenue",
                  icon: "error",
                  position: "top",
                });
              }
            }
          );
      }
    });
  }

  onChangeStatus($event) {
    this.selectedStatus = $event.target.value;
    this.current_page = 1;
    this.reservations = [];
    this.has_more = false;
    this.get_my_reservations(true);
  }

  dateWithoutTimeZone(date: any) {
    return this.dateFormatterService.showDateHour(date);
  }
}